'use strict';

// This are the x and y coordinates of the dots. x1 and y1 represent the dots position in the arc; x2 and y2 are the dots in the bars.

module.exports.positions = {
  dem: [
    {
      x1: 98.97,
      y1: 308.53,
      x2: 328.57,
      y2: 263.44
    },
    {
      x1: 134.98,
      y1: 308.48,
      x2: 296.97,
      y2: 263.44
    },
    {
      x1: 170.36,
      y1: 308.48,
      x2: 265.62,
      y2: 263.44
    },
    {
      x1: 205.85,
      y1: 308.48,
      x2: 233.19,
      y2: 263.44
    },
    {
      x1: 241.35,
      y1: 307.48,
      x2: 201.67,
      y2: 263.44
    },
    {
      x1: 103.65,
      y1: 274.4,
      x2: 328.57,
      y2: 232.33
    },
    {
      x1: 139.64,
      y1: 274.85,
      x2: 296.97,
      y2: 232.33
    },
    {
      x1: 175.77,
      y1: 274.4,
      x2: 265.62,
      y2: 232.33
    },
    {
      x1: 212.25,
      y1: 274.4,
      x2: 233.19,
      y2: 232.33
    },
    {
      x1: 249.17,
      y1: 273.76,
      x2: 201.67,
      y2: 232.33
    },
    {
      x1: 265.87,
      y1: 240.93,
      x2: 328.57,
      y2: 201.23
    },
    {
      x1: 225.85,
      y1: 240.82,
      x2: 296.97,
      y2: 201.23
    },
    {
      x1: 187.28,
      y1: 240.93,
      x2: 265.62,
      y2: 201.23
    },
    {
      x1: 149.56,
      y1: 240.82,
      x2: 233.19,
      y2: 201.23
    },
    {
      x1: 112.44,
      y1: 240.82,
      x2: 201.67,
      y2: 201.23
    },
    {
      x1: 125.73,
      y1: 209.44,
      x2: 233.19,
      y2: 170.13
    },
    {
      x1: 164.65,
      y1: 209.76,
      x2: 201.67,
      y2: 170.13
    },
    {
      x1: 204.86,
      y1: 209.76,
      x2: 45.19,
      y2: 263.44
    },
    {
      x1: 246.24,
      y1: 211.4,
      x2: 76.28,
      y2: 263.44
    },
    {
      x1: 290.47,
      y1: 213.73,
      x2: 170.67,
      y2: 263.44
    },
    {
      x1: 321.64,
      y1: 190.99,
      x2: 139.24,
      y2: 263.44
    },
    {
      x1: 272.68,
      y1: 184.52,
      x2: 107.72,
      y2: 263.44
    },
    {
      x1: 227.39,
      y1: 181.13,
      x2: 45.19,
      y2: 232.33
    },
    {
      x1: 184.54,
      y1: 179.04,
      x2: 76.28,
      y2: 232.33
    },
    {
      x1: 143.4,
      y1: 177.96,
      x2: 170.67,
      y2: 232.33
    },
    {
      x1: 165.14,
      y1: 147.05,
      x2: 139.24,
      y2: 232.33
    },
    {
      x1: 208.88,
      y1: 150.46,
      x2: 107.72,
      y2: 232.33
    },
    {
      x1: 254.95,
      y1: 154.32,
      x2: 45.19,
      y2: 201.23
    },
    {
      x1: 304.57,
      y1: 162.18,
      x2: 76.28,
      y2: 201.23
    },
    {
      x1: 358.03,
      y1: 175.07,
      x2: 170.67,
      y2: 201.23
    },
    {
      x1: 339.76,
      y1: 145.18,
      x2: 139.24,
      y2: 201.23
    },
    {
      x1: 286.79,
      y1: 132.36,
      x2: 107.72,
      y2: 201.23
    },
    {
      x1: 237.25,
      y1: 124.51,
      x2: 45.19,
      y2: 170.13
    },
    {
      x1: 190.44,
      y1: 119.29,
      x2: 76.28,
      y2: 170.13
    },
    {
      x1: 219.52,
      y1: 94.29,
      x2: 170.67,
      y2: 170.13
    },
    {
      x1: 269.29,
      y1: 102.96,
      x2: 139.24,
      y2: 170.13
    },
    {
      x1: 322.03,
      y1: 115.22,
      x2: 107.72,
      y2: 170.13
    },
    {
      x1: 359.08,
      y1: 102.96,
      x2: 328.57,
      y2: 170.13
    },
    {
      x1: 397.98,
      y1: 96.67,
      x2: 296.97,
      y2: 170.13
    },
    {
      x1: 251.36,
      y1: 73,
      x2: 265.62,
      y2: 170.13
    },
    {
      x1: 285.79,
      y1: 55.75,
      x2: 45.19,
      y2: 138.33
    },
    {
      x1: 303.64,
      y1: 85.48,
      x2: 201.97,
      y2: 138.73
    },
    {
      x1: 321.64,
      y1: 41.54,
      x2: 170.54,
      y2: 138.73
    },
    {
      x1: 340.41,
      y1: 72.41,
      x2: 139.02,
      y2: 138.73
    },
    {
      x1: 378.67,
      y1: 64.23,
      x2: 107.59,
      y2: 138.73
    },
    {
      x1: 359.58,
      y1: 32.45,
      x2: 76.5,
      y2: 138.73
    }
  ],
  gop: [
    {
      x1: 594.6,
      y1: 307.48,
      x2: 381.96,
      y2: 263.64
    },
    {
      x1: 630.08,
      y1: 307.48,
      x2: 412.05,
      y2: 263.64
    },
    {
      x1: 665.04,
      y1: 307.48,
      x2: 505.43,
      y2: 263.64
    },
    {
      x1: 700.54,
      y1: 307.48,
      x2: 474,
      y2: 263.64
    },
    {
      x1: 586.25,
      y1: 274.14,
      x2: 442.48,
      y2: 263.64
    },
    {
      x1: 623.56,
      y1: 273.76,
      x2: 381.96,
      y2: 232.53
    },
    {
      x1: 659.45,
      y1: 274.41,
      x2: 412.05,
      y2: 232.53
    },
    {
      x1: 695.71,
      y1: 274.14,
      x2: 505.43,
      y2: 232.53
    },
    {
      x1: 731.77,
      y1: 274.41,
      x2: 474,
      y2: 232.53
    },
    {
      x1: 569.56,
      y1: 240.67,
      x2: 442.48,
      y2: 232.53
    },
    {
      x1: 609.57,
      y1: 240.67,
      x2: 381.96,
      y2: 201.43
    },
    {
      x1: 648.13,
      y1: 240.67,
      x2: 412.05,
      y2: 201.43
    },
    {
      x1: 685.45,
      y1: 240.94,
      x2: 505.43,
      y2: 201.43
    },
    {
      x1: 722.98,
      y1: 240.67,
      x2: 474,
      y2: 201.43
    },
    {
      x1: 544.29,
      y1: 213.73,
      x2: 442.48,
      y2: 201.43
    },
    {
      x1: 589.18,
      y1: 211.4,
      x2: 381.96,
      y2: 169.33
    },
    {
      x1: 630.54,
      y1: 210.29,
      x2: 412.05,
      y2: 169.33
    },
    {
      x1: 670.36,
      y1: 209.76,
      x2: 505.43,
      y2: 169.33
    },
    {
      x1: 709.87,
      y1: 209.43,
      x2: 474,
      y2: 169.33
    },
    {
      x1: 513.78,
      y1: 190.99,
      x2: 442.48,
      y2: 169.33
    },
    {
      x1: 562.75,
      y1: 184.54,
      x2: 381.96,
      y2: 138.23
    },
    {
      x1: 608.26,
      y1: 181.13,
      x2: 412.05,
      y2: 138.23
    },
    {
      x1: 650.87,
      y1: 179.04,
      x2: 662.77,
      y2: 264.14
    },
    {
      x1: 692.02,
      y1: 177.97,
      x2: 631.16,
      y2: 264.14
    },
    {
      x1: 477.38,
      y1: 175.07,
      x2: 599.82,
      y2: 264.14
    },
    {
      x1: 530.92,
      y1: 162.2,
      x2: 568.38,
      y2: 264.14
    },
    {
      x1: 580.63,
      y1: 155.03,
      x2: 537.86,
      y2: 264.14
    },
    {
      x1: 626.55,
      y1: 150.46,
      x2: 662.77,
      y2: 233.03
    },
    {
      x1: 670.29,
      y1: 148.2,
      x2: 631.16,
      y2: 233.03
    },
    {
      x1: 495.68,
      y1: 145.18,
      x2: 599.82,
      y2: 233.03
    },
    {
      x1: 437.66,
      y1: 165.84,
      x2: 568.38,
      y2: 233.03
    },
    {
      x1: 457.4,
      y1: 134.4,
      x2: 537.86,
      y2: 233.03
    },
    {
      x1: 548.78,
      y1: 132.41,
      x2: 662.77,
      y2: 201.93
    },
    {
      x1: 598.16,
      y1: 124.51,
      x2: 631.16,
      y2: 201.93
    },
    {
      x1: 645.01,
      y1: 119.3,
      x2: 599.82,
      y2: 201.93
    },
    {
      x1: 513.78,
      y1: 115.31,
      x2: 568.38,
      y2: 201.93
    },
    {
      x1: 566.42,
      y1: 102.96,
      x2: 537.86,
      y2: 201.93
    },
    {
      x1: 615.88,
      y1: 93.99,
      x2: 662.77,
      y2: 169.83
    },
    {
      x1: 417.6,
      y1: 130.28,
      x2: 631.16,
      y2: 169.83
    },
    {
      x1: 476.34,
      y1: 102.72,
      x2: 599.82,
      y2: 169.83
    },
    {
      x1: 531.79,
      y1: 85.54,
      x2: 568.38,
      y2: 169.83
    },
    {
      x1: 583.66,
      y1: 73.04,
      x2: 537.86,
      y2: 169.83
    },
    {
      x1: 550.25,
      y1: 55.71,
      x2: 662.77,
      y2: 138.73
    },
    {
      x1: 495.01,
      y1: 72.41,
      x2: 631.16,
      y2: 138.73
    },
    {
      x1: 437.96,
      y1: 96.67,
      x2: 599.82,
      y2: 138.73
    },
    {
      x1: 456.74,
      y1: 64.23,
      x2: 568.38,
      y2: 138.73
    },
    {
      x1: 418.47,
      y1: 62.12,
      x2: 537.86,
      y2: 138.73
    },
    {
      x1: 513.42,
      y1: 41.67,
      x2: 505.43,
      y2: 138.23
    },
    {
      x1: 475.74,
      y1: 32.45,
      x2: 474,
      y2: 138.23
    },
    {
      x1: 436.94,
      y1: 27.98,
      x2: 442.48,
      y2: 138.23
    },
    {
      x1: 397.52,
      y1: 27.98,
      x2: 412.48,
      y2: 107.23
    },
    {
      x1: 734.48,
      y1: 307.53,
      x2: 381.96,
      y2: 107.23
    }
  ],
  independent: [
    {
      x1: 377.95,
      y1: 134.21,
      x2: 717.29,
      y2: 264.14
    },
    {
      x1: 397.52,
      y1: 165.84,
      x2: 748.72,
      y2: 264.14
    }
  ]
};
